module.exports = __webpack_public_path__ + "static/images/cover_A4.2137cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_A4.png
// module id = KiGY
// module chunks = 8